import React, { forwardRef } from 'react';
import { useTheme } from '../App';

const Post = forwardRef(({ post, index, isSelected, onSelect }, ref) => {
  const { theme } = useTheme();

  const handleClick = () => {
    if (!post.is_self && post.num_comments === 0) {
      window.open(post.url, '_blank', 'noopener,noreferrer');
    } else {
      onSelect();
    }
  };

  /*
   * Each post is rendered as a small card with a subtle border and shadow.
   * Increasing the padding and rounding the corners makes the feed easier
   * to scan and interact with. When selected, the card uses a slightly
   * darker background to stand out from the rest of the list.
   */
  const containerStyle = {
    marginBottom: '10px',
    backgroundColor: isSelected ? theme.colors.background2 : theme.colors.background3,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '6px',
    // Reduce padding slightly for a more compact feel
    padding: '10px',
    color: theme.colors.foreground,
    transition: 'background-color 0.2s, border-color 0.2s',
  };

  return (
    <div style={containerStyle} ref={ref}>
      <div
        onClick={handleClick}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        {/* Index number */}
        <span
          style={{
            color: isSelected ? theme.colors.accentGreen : theme.colors.accentCyan,
            minWidth: '36px',
            fontSize: '13px',
            fontWeight: 600,
            textAlign: 'right',
          }}
        >
          {String(index + 1).padStart(2, ' ')}.
        </span>
        {/* Subreddit name */}
        <span
          style={{
            color: theme.colors.accentOrange,
            fontSize: '12px',
            minWidth: '120px',
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 500,
          }}
        >
          r/{post.subreddit}
        </span>
        {/* Post title */}
        <span
          style={{
            flex: 1,
            fontSize: '14px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 500,
          }}
        >
          {post.title}
        </span>
        {/* Comment count */}
        {post.num_comments > 0 && (
          <span
            style={{
              color: theme.colors.accentPurple,
              fontSize: '12px',
              whiteSpace: 'nowrap',
              fontWeight: 500,
            }}
          >
            💬 {post.num_comments}
          </span>
        )}
        {/* Score */}
        <span
          style={{
            color: theme.colors.accentGreen,
            fontSize: '12px',
            whiteSpace: 'nowrap',
            fontWeight: 500,
          }}
        >
          ▲ {post.score}
        </span>
      </div>
    </div>
  );
});

export default Post;